import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraSearchField } from '../lieutenants/search-field';
/** Search, filters, view modes, and actions for list/table pages. */ export function SpecraFilterToolbar({ actions, className, filters, resultSummary, search, viewControl, ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex flex-col items-stretch gap-2 border-b border-border pb-3 sm:flex-row sm:flex-wrap sm:items-center', className),
        ...props,
        children: [
            search !== false ? /*#__PURE__*/ _jsx(SpecraSearchField, {
                className: "w-full sm:w-64",
                ...search
            }) : null,
            filters ? /*#__PURE__*/ _jsx("div", {
                className: "flex max-w-full flex-wrap items-center gap-2",
                children: filters
            }) : null,
            resultSummary ? /*#__PURE__*/ _jsx("div", {
                className: "text-[length:var(--fs-ui-caption)] text-muted-foreground",
                children: resultSummary
            }) : null,
            /*#__PURE__*/ _jsx("div", {
                className: "hidden min-w-0 flex-1 sm:block"
            }),
            viewControl,
            actions ? /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap items-center gap-2",
                children: actions
            }) : null
        ]
    });
}
